

exports.__esModule = true;
exports.$forbiddenHandler = $forbiddenHandler;
exports.$exceptionHandler = $exceptionHandler;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _fallback = require('./fallback');

function constructEventName(toState, fromState) {
    var from = fromState.name.replace(/\./g, '_') || 'start';
    var to = toState.name.replace(/\./g, '_') || 'end';

    return 'state_change_' + from + '_to_' + to;
}

function $forbiddenHandler(err) {
    _logger.$logger.warn('forbidden_handler');
    if (!err.transient) {
        return _uiRouter.$state.go('checkout.genericError');
    }
}

var ERROR_HANDLERS = [{
    type: _squid.$FallbackError,
    handler: _fallback.$fallbackErrorHandler
}, {
    type: _squid.$Forbidden,
    handler: $forbiddenHandler
}];

function $exceptionHandler(err, cause) {

    if (_angular.$rootScope.ERROR_STATE) {

        if (_angular.$rootScope.ERROR_PREVENTED) {
            throw err;
        }

        return;
    }

    var handled = _squid.$util.some(ERROR_HANDLERS, function (errorHandler) {
        if (err instanceof errorHandler.type) {
            errorHandler.handler(err);

            return true;
        }
    });

    if (handled) {
        return;
    } else if (!err.transient) {
        _angular.$rootScope.ERROR_STATE = err;
    }

    var errType = (err.constructor.name || 'error').toLowerCase();
    var errName = 'ui_unhandled_' + errType;
    var errMsg = err.message || '';

    if (errMsg.indexOf('infdig') > -1) {
        errName = 'infinite_digest';
    } else if (errMsg.indexOf('inprog') > -1) {
        errName = 'digest_inprog';
    } else if (errMsg.indexOf('badparse') > -1) {
        errName = 'sanitize_badparse';
    } else if (errMsg.match(/^[\w_]+$/)) {
        errName = 'ui_unhandled_' + errMsg;
    }

    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
            errName = 'ui_unhandled_framework_error';
        }
    }

    if (err.transient) {
        errName += '_transient';
    }

    var payload = {
        error: err.stack || err.toString(),
        message: errMsg,
        cause: cause && cause.toString(),
        state: _uiRouter.$state.current.name,
        url: window.location.toString()
    };

    angular.extend(payload, err.payload || {});

    _logger.$logger.error(errName, payload);

    if (errName === 'ui_unhandled_noack') {
        return _uiRouter.$state.go('checkout.genericError');
    }

    // emit the error object for subscribers like xo-tracking
    var event = _angular.$rootScope.$emit('unhandled_error', {
        err: err,
        route: (_uiRouter.$state || {}).current,
        message: payload.error,
        code: payload.cause
    });

    if (event.defaultPrevented) {
        _angular.$rootScope.ERROR_PREVENTED = true;
        throw err;
    } else if (!err.transient) {
        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
            reason: errName
        }));
    }
}

_angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
    // Set prevent default to avoid angular UI router to keep looping back to same state
    event.preventDefault();
    $exceptionHandler(err, constructEventName(toState, fromState));
});

_angular.$rootScope.$on('$windowError', function (event, details) {
    _logger.$logger.error('window_error', details, {
        unique: true
    });
});

angular.value("$forbiddenHandler", $forbiddenHandler);
angular.value("$exceptionHandlerLazy", $exceptionHandler);
_angular.$rootScope;

_uiRouter.$state;

_squid.$util;

_squid.$FallbackError;

_squid.$Forbidden;

_logger.$logger;

_fallback.$fallbackErrorHandler;


//////////////////
// WEBPACK FOOTER
// ./js/lib/error.js
// module id = ./js/lib/error.js
// module chunks = 1